module.exports = __webpack_public_path__ + "img/12_andy_s.b5b0a7c5.png";